/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} File_PresentInputs */



/**
* | output |
* | --- |
* | "File Present" |
*
* @param {File_PresentInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const file_present = /** @type {((inputs?: File_PresentInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<File_PresentInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fichier présent")
	if (locale === "de") return /** @type {LocalizedString} */ ("Datei vorhanden")
	if (locale === "it") return /** @type {LocalizedString} */ ("File presente")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Файл присутствует")
	if (locale === "es") return /** @type {LocalizedString} */ ("Archivo presente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("文件存在")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ファイルあり")
	if (locale === "hi") return /** @type {LocalizedString} */ ("फ़ाइल मौजूद है")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Apresentar Arquivo")
	return /** @type {LocalizedString} */ ("File Present")
});